var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "m-grid__item m-grid__item--fluid m-wrapper breadcums-barr"
      },
      [
        _c("div", { staticClass: "m-subheader" }, [
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _c("div", { staticClass: "mr-auto" }, [
              _c(
                "ul",
                { staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline" },
                [
                  _c("li", { staticClass: "m-nav__item" }, [
                    _c("span", { staticClass: "m-nav__link-text" }, [
                      _vm._v(
                        "\n\t\t  \t\t\t\t\t\t" +
                          _vm._s(_vm.property) +
                          "\n\t\t  \t\t\t\t\t"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "m-nav__separator" }, [
                    _vm._v("\n\t\t  \t\t\t\t\t-\n\t\t  \t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "m-nav__item" }, [
                    _c("span", { staticClass: "m-nav__link-text" }, [
                      _vm._v(
                        "\n\t\t  \t\t\t\t\t\t" +
                          _vm._s(_vm.company) +
                          "\n\t\t  \t\t\t\t\t"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "m-nav__separator" }, [
                    _vm._v("\n\t\t  \t\t\t\t\t-\n\t\t  \t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "m-nav__item" }, [
                    _c("span", { staticClass: "m-nav__link-text" }, [
                      _vm._v(
                        "\n\t\t  \t\t\t\t\t\t" +
                          _vm._s(_vm.profile) +
                          "\n\t\t  \t\t\t\t\t"
                      )
                    ])
                  ])
                ]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "option" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "contentData" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm._f("capitalize")("date_time")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "result" }, [
            _vm._v("\n            " + _vm._s(this.currentTime) + "\n          ")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "option" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "contentData" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm._f("capitalize")("ip_address_monitor")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "result" }, [
            _c("div", [
              _c("b", [
                _vm._v(_vm._s(_vm._f("capitalize")("ip_address")) + ":")
              ]),
              _vm._v(" " + _vm._s(_vm.ip))
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [_vm._v(_vm._s(_vm._f("capitalize")("netmask")) + ":")]),
              _vm._v(" " + _vm._s(_vm.netmask))
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [_vm._v(_vm._s(_vm._f("capitalize")("gateway")) + ":")]),
              _vm._v(" " + _vm._s(_vm.broadcast))
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [
                _vm._v(_vm._s(_vm._f("capitalize")("addressing_monitor")) + ":")
              ]),
              _vm._v(" " + _vm._s(_vm._f("capitalize")(_vm.typeNetplan)))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "option" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "contentData" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm._f("capitalize")("basic_data")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "result" }, [
            _c("div", [
              _c("b", [_vm._v(_vm._s(_vm._f("capitalize")("property")) + ":")]),
              _vm._v(" " + _vm._s(_vm.property))
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [_vm._v(_vm._s(_vm._f("capitalize")("database")) + ":")]),
              _vm._v(" " + _vm._s(_vm.database))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "option" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "contentData" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm._f("capitalize")("memory_ram")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "result" }, [
            _c("div", [
              _c("b", [_vm._v(_vm._s(_vm._f("capitalize")("total")) + ":")]),
              _vm._v(" " + _vm._s(_vm.memoryTotal) + "G")
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [_vm._v(_vm._s(_vm._f("capitalize")("used")) + ":")]),
              _vm._v(" " + _vm._s(_vm.memoryUsed) + "G")
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [_vm._v(_vm._s(_vm._f("capitalize")("free")) + ":")]),
              _vm._v(" " + _vm._s(_vm.memoryFree) + "G")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "option" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "contentData" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm._f("capitalize")("hard_disk")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "result" }, [
            _c("div", [
              _c("b", [_vm._v(_vm._s(_vm._f("capitalize")("total")) + ":")]),
              _vm._v(" " + _vm._s(_vm.diskTotal))
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [_vm._v(_vm._s(_vm._f("capitalize")("used")) + ":")]),
              _vm._v(" " + _vm._s(_vm.diskUsed))
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [_vm._v(_vm._s(_vm._f("capitalize")("free")) + ":")]),
              _vm._v(" " + _vm._s(_vm.diskFree))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "option" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "contentData" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm._f("capitalize")("CPU")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "result" }, [
            _c("div", [
              _c("b", [_vm._v(_vm._s(_vm._f("capitalize")("CPU")) + ":")]),
              _vm._v(" " + _vm._s(_vm.referenceCpu))
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [_vm._v(_vm._s(_vm._f("capitalize")("cores")) + ":")]),
              _vm._v(" " + _vm._s(_vm.countCoreCpu))
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [
                _vm._v(
                  _vm._s(_vm._f("capitalize")("temperature")) +
                    ": " +
                    _vm._s(_vm._f("capitalize")(_vm.temperatureCpu))
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "option" }, [
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "contentData" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm._f("capitalize")("operative_system")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "result" }, [
            _vm._v(_vm._s(_vm.operativeSystem))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "option" }, [
        _vm._m(7),
        _vm._v(" "),
        _c("div", { staticClass: "contentData" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm._f("capitalize")("execution_status")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "result" }, [
            _c("div", [
              _c("b", [
                _vm._v(_vm._s(_vm._f("capitalize")("last_sync_up")) + ":")
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm._f("capitalize")(_vm.lastSyncUp)))
              ]),
              _vm._v(" "),
              _vm.sincronizationUp === false
                ? _c("span", { staticClass: "inactive" }, [
                    _vm._v(_vm._s(_vm._f("capitalize")("disconnected")))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", [
              _c("b", [
                _vm._v(_vm._s(_vm._f("capitalize")("last_sync_down")) + ":")
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm._f("capitalize")(_vm.lastSyncDown)))
              ]),
              _vm._v(" "),
              _vm.sincronizationDown === false
                ? _c("span", { staticClass: "inactive" }, [
                    _vm._v(_vm._s(_vm._f("capitalize")("disconnected")))
                  ])
                : _vm._e()
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "option" }, [
        _vm._m(8),
        _vm._v(" "),
        _c("div", { staticClass: "contentData" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm._f("capitalize")("firmware_version")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "result" }, [_vm._v(_vm._s(_vm.firmware))])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contentIcon" }, [
      _c("div", { staticClass: "icon fa fa-clock-o" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contentIcon" }, [
      _c("div", { staticClass: "icon fa fa-sitemap" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contentIcon" }, [
      _c("div", { staticClass: "icon fa fa-building" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contentIcon" }, [
      _c("div", { staticClass: "icon fa fa-tasks" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contentIcon" }, [
      _c("div", { staticClass: "icon fa fa-database" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contentIcon" }, [
      _c("div", { staticClass: "icon fa fa-microchip" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contentIcon" }, [
      _c("div", { staticClass: "icon fa fa-desktop" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contentIcon" }, [
      _c("div", { staticClass: "icon fa fa-check-square" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "contentIcon" }, [
      _c("div", { staticClass: "icon fa fa-server" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b125397", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b125397","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/home/Home.vue
// module id = 797
// module chunks = 0 1 52